var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/* eslint react/prop-types: 0 */
import React from 'react';
import * as R from 'ramda';
export var withInput = function withInput(Component) {
  return function (_React$Component) {
    _inherits(_class2, _React$Component);
    function _class2() {
      var _temp, _this, _ret;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
        value: _this.props.value || ''
      }, _this.onChange = function (value) {
        _this.setState({
          value: value
        });
      }, _this.onSubmit = function () {
        _this.bubbleUp(_this.state.value);
      }, _this.bubbleUp = function (item) {
        if (R.is(Function, _this.props.onSubmit)) _this.props.onSubmit(item);
      }, _this.render = function () {
        var _this$props = _this.props,
          onChange = _this$props.onChange,
          onSubmit = _this$props.onSubmit,
          isControlled = _this$props.isControlled,
          isBlank = _this$props.isBlank;
        if (isBlank) return null;
        var value = _this.state.value;
        return React.createElement(Component, _extends({}, _this.props, {
          onChange: isControlled ? onChange : _this.onChange,
          onSubmit: isControlled ? onSubmit : _this.onSubmit,
          value: isControlled ? _this.props.value : value
        }));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    return _class2;
  }(React.Component);
};